<template>
	<v-textarea
		v-model="localVal"
		class="text-area"
		rows="3"
		solo
		no-resize
		hide-details
		:placeholder="placeholder"
		:readonly="readonly"
	></v-textarea>
</template>

<script>
export default {
	name: 'TextArea',
	props: {
		value: { type: String, required: true },
		placeholder: { type: String },
		readonly: { type: Boolean, default: false },
	},
	computed: {
		localVal: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit('update:value', value);
			},
		},
	},
};
</script>
<style scoped lang="scss">
.text-area ::v-deep {
	.v-input__control .v-input__slot {
		padding: 0 0 !important;
		border-radius: var(--border-radius) !important;
		box-shadow: none !important;
	}
	.v-input__control .v-input__slot textarea {
		color: var(--input-text-color);
		background-color: var(--input-bg-color) !important;
		border-radius: var(--border-radius);
		border: var(--primary-border);
	}
	textarea {
		padding: 6px 10px;
		margin-top: 0;
		font-size: var(--font-size-4);
	}
}
</style>
